import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { environment } from '../../environments/environment'


@Injectable({
  providedIn: 'root'
})

export class InvitationsService {
  readonly APIurl = environment.apiUrl;
  readonly APIBase = `${this.APIurl}/Invitations`;

  constructor(private http: HttpClient) { }

  send(val: any) {
    return this.http.post(`${this.APIBase}/WindoRex/`, val);
  }

  list(){
    return this.http.get(`${this.APIBase}`);
  }

  download(){
    return this.http.get(`${this.APIBase}/data`);
  }
}
